/**
 * Remember the pharmacist's pharmacy-store pick across the session.
 *
 * Same pattern as StockBalances' `inv_selected_store` (its own key, so the
 * stock module's pick and the pharmacy counter's pick don't fight each other).
 * sessionStorage, not localStorage, on purpose: a shared hospital terminal
 * must not leak one login's store into the next.
 *
 * Every access is try/catched — storage can throw in private windows, and a
 * store default is a convenience, never worth breaking the page over.
 */
const KEY = 'inv_pharmacy_store';

export function readPreferredPharmacyStore() {
  try {
    return sessionStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}

export function writePreferredPharmacyStore(storeId) {
  if (!storeId) return;
  try {
    sessionStorage.setItem(KEY, String(storeId));
  } catch {
    /* convenience only */
  }
}
